module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg13-edd4aea08dabdf39c7e67a065450527b.png";